import { TAppThunkDispatch, TGetState } from '~/src/store';

import { initializePaymentState } from '../actionCreators';
// import { confirmedEmails } from '../selectors/emails';

// TODO: раскомментировать строки 5, 14, 16, 23
// после выполнения задачи биллинга https://ticket.ertelecom.ru/browse/DEV-124161
const initPaymentState = (querySum?: number) => {
    return (dispatch: TAppThunkDispatch, getState: TGetState): void => {
        const state = getState();
        const {
            auth: { isAuth, clientPayment },
        } = state;

        // const emails = confirmedEmails(state);

        const { paySum } = clientPayment || {};

        const paymentSum = querySum ? querySum : (isAuth && paySum) ? Math.floor(paySum * 100) / 100 : 0;
        // const email = (isAuth && !!emails.length) ? emails[0] : '';

        dispatch(initializePaymentState({
            paymentSum,
            // email,
            isUseBonuses: false,
            bonusesValue: 0,
            isSaveCard: true,
            isConnectAutoPay: false,
            agreement: '',
            agreementEnc: '',
        }));
    };
};

export default initPaymentState;
